import { render, staticRenderFns } from "./add_member.vue?vue&type=template&id=687b4faf&scoped=true"
import script from "./add_member.vue?vue&type=script&lang=ts"
export * from "./add_member.vue?vue&type=script&lang=ts"
import style0 from "./add_member.vue?vue&type=style&index=0&id=687b4faf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687b4faf",
  null
  
)

export default component.exports